if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    
      this.handleErrorMessage();
      this.toggleSubmitButton(true, 'Adding...');
    
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
    
      const formData = new FormData(this.form);

      const quantities = formData.getAll('quantity');
      if (quantities.length > 1) {
        formData.delete('quantity');
        formData.append('quantity', quantities[0]);
      }

      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;
    
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.error = true;
            this.toggleSubmitButton(false);
            return;
          }
    
          this.error = false;
    
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  if (this.cart && typeof this.cart.renderContents === 'function') this.cart.renderContents(response);
                  this.toggleSubmitButton(false);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            if (this.cart && typeof this.cart.renderContents === 'function') this.cart.renderContents(response);
            this.toggleSubmitButton(false);
          }

          // Dispatch custom event for cart addition
          const cartAddedEvent = new CustomEvent('cart:added', { 
            bubbles: true, 
            detail: { response: response } 
          });
          this.dispatchEvent(cartAddedEvent);
        })
        .catch((e) => {
          console.error(e);
          this.toggleSubmitButton(false);
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (!this.submitButton) return;
      
      const submitText = this.submitButton.querySelector('.button__text');
      if (submitText && text) submitText.textContent = text;
    
      if (disable) {
        this.submitButton.setAttribute('aria-disabled', true);
      } else {
        this.submitButton.removeAttribute('aria-disabled');
        // Reset text to original if provided
        if (submitText) submitText.textContent = submitText.dataset.originalText || 'Add to Cart';
      }
    }
  }
  
  customElements.define('product-form', ProductForm);
}